import MuiTooltip from '@mui/material/Tooltip';
import React, { useEffect, useState } from 'react';

import { useCommentLikersText } from '../../../hooks';
import LikeIcon from './LikeIcon';
import styles from './styles.module.css';

export default function LikesCount({ count, commentId }: { commentId: number; count: number }) {
  const [enabled, setEnabled] = useState(false);
  const { likersFor } = useCommentLikersText(commentId, enabled);

  useEffect(() => {
    if (!enabled && count > 0) {
      setEnabled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  return (
    <MuiTooltip arrow placement="top" title={likersFor || ''} disableHoverListener={!enabled}>
      <div className={styles.likesCount}>
        <LikeIcon />
        {count > 0 && <span className={styles.count}>{count}</span>}
      </div>
    </MuiTooltip>
  );
}
